import React, { useContext } from "react";
import {
    DoughnutChart,
    regisrationChartOptions,
    StatisticsContainer,
    StatisticsContent,
} from "modules/common";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    numberOfFarmers: number;
    numberOfCitizens: number;
    total: number;
}
export const RegistrationStats: React.FC<Props> = ({
    numberOfCitizens,
    numberOfFarmers,
    total,
}) => {
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <StatisticsContainer title="Broj registriranih korisnika" className={lowVision ? "low-vision-darkgray" : ""}>
            <div className="statistics-chart">
                <DoughnutChart
                    options={regisrationChartOptions}
                    data={[numberOfFarmers, numberOfCitizens]}
                    label="Ukupno"
                    value={total.toString()}
                />
            </div>
            <StatisticsContent>
                <div className="stats-row">
                    <div className="dot dot--terracota" />
                    <p className="stats-text">Poljoprivrednika</p>
                </div>
                <div className="stats-value">{numberOfFarmers}</div>
                <div className="stats-row">
                    <div className="dot dot--royalBlue" />
                    <p className="stats-text">Građana</p>
                </div>
                <div className="stats-value">{numberOfCitizens}</div>
            </StatisticsContent>
        </StatisticsContainer>
    );
};
